import React from "react";
import { Modal } from "@/components/ui";
import { fmt, fmtDate } from "@/lib/formatters";
import { Package, ClipboardList, User, MapPin } from "lucide-react";

export const ViewMaterialExpenseModal = ({ isOpen, onClose, expense }) => {
  if (!expense) return null;

  const Card = ({ label, v, fullWidth = false }) => (
    <div className={`bg-slate-50 rounded-lg p-3 ${fullWidth ? "col-span-2" : ""}`}>
      <div className="text-[10px] text-slate-500 mb-0.5 uppercase font-bold tracking-wider opacity-70">
        {label}
      </div>
      <div className="text-xs font-semibold text-brand-dark">
        {v !== undefined && v !== null && v !== "" ? String(v) : "—"}
      </div>
    </div>
  );

  const quotationNo = expense.quotationNo || expense.invoiceNo || "—";
  const customerName = expense.clientName || "—";
  const phone = expense.contactPhone || "—";
  const email = expense.contactEmail || "—";
  const address = expense.address || "—";
  const category = expense.category || (expense.type === "ordering" ? "ORDERING" : "FINAL QUOTATION");
  const raisedBy = expense.raisedBy || "—";
  const verveId = expense.customId || "—";
  const date = expense.date ? fmtDate(expense.date) : "—";

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Material Expense — ${quotationNo}`} size="max-w-lg">
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3">

          {/* Quotation Info */}
          <Card label="Verve ID" v={verveId} />
          <Card label="Quotation No" v={quotationNo} />
          <Card label="Category" v={category} />
          <Card label="Date" v={date} />

          {/* Customer Info */}
          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-brand-blue uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <User size={14} /> Customer Info
            </label>
          </div>
          <Card label="Customer Name" v={customerName} fullWidth />
          <Card label="Phone" v={phone} />
          <Card label="Email" v={email} />

          {/* Address */}
          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-emerald-600 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <MapPin size={14} /> Address & Financials
            </label>
          </div>
          <Card label="Address" v={address} fullWidth />
          <Card label="Amount" v={`₹${fmt(expense.amount || expense.totalAmount || 0)}`} />
          <Card label="Status" v={expense.status ? expense.status.toUpperCase() : "—"} />

          {/* Additional Info */}
          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-slate-500 uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <ClipboardList size={14} /> Additional Info
            </label>
          </div>
          <Card label="Raised By" v={raisedBy} />
          {/* 
          <Card label="Reason" v={expense.reason} />
          <Card label="Requester Notes" v={expense.requesterNotes} />
          <Card label="Approver Notes" v={expense.approverNotes} />
          */}
        </div>
      </div>
    </Modal>
  );
};
